import script from "./NextButton.vue?vue&type=script&setup=true&lang=js"
export * from "./NextButton.vue?vue&type=script&setup=true&lang=js"

import "./NextButton.vue?vue&type=style&index=0&id=dbe2eb74&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-dbe2eb74"]])

export default __exports__